import { createSlice } from "@reduxjs/toolkit";
import { TYPE_DATE } from "constants/enums";
import { format, parse, subMonths } from "date-fns";
import { getDashDataType } from "utils";

const date = new Date();
const firstDay = new Date(date.getFullYear(), date.getMonth(), 1, 1);
const currentDay = new Date(
  date.getFullYear(),
  date.getMonth(),
  date.getDate(),
  1,
);

const dataType = getDashDataType();

const cardDefault = {
  dateInit: firstDay,
  dateEnd: currentDay,
  dateRange: [firstDay, currentDay],
  tag: dataType,
};

const cardDefaultPast = {
  ...cardDefault,
  dateInitPast: parse(
    format(subMonths(currentDay, 1), "yyyy-MM-01"),
    "yyyy-MM-dd",
    1,
  ),
  dateEndPast: subMonths(currentDay, 1),
};

const dashboardDefault = {
  tag: dataType,
  cardAll: { ...cardDefault },
  cardSale: { ...cardDefaultPast },
  cardPurchase: { ...cardDefaultPast },
  cardPisCofins: { ...cardDefault },
  cardIcms: { ...cardDefault },
  cardMiniVendasTotals: { ...cardDefault },
  cardMiniComprasTotals: { ...cardDefault },
  cardMiniSkuVendidosTotals: { ...cardDefault },
  cardDinheiroMesa: { ...cardDefault },
  cardCuidadoTentacao: { ...cardDefault },
  cardQueimaCaixa: { ...cardDefault },
  cardRiscoAssumido: { ...cardDefault },
  cardReprecificacao: { ...cardDefault },
  cardProdutosVendidos: { ...cardDefault },
  cardOlhoMargem: { ...cardDefault },
  alertsModal: {
    isOpen: false,
    alert: null,
  },
  periodMonthly: TYPE_DATE.MONTHLY,
};

const handleCardSaleReducer = (state, { payload }) => {
  state.cardSale.dateInit = payload.dateInit;
  state.cardSale.dateEnd = payload.dateEnd;
  state.cardSale.dateRange = payload.dateRange;
  state.cardSale.dateInitPast = subMonths(payload.dateInit, 1);
  state.cardSale.dateEndPast = subMonths(payload.dateEnd, 1);
};

const handleCardPurchaseReducer = (state, { payload }) => {
  state.cardPurchase.dateInit = payload.dateInit;
  state.cardPurchase.dateEnd = payload.dateEnd;
  state.cardPurchase.dateRange = payload.dateRange;
  state.cardPurchase.dateInitPast = subMonths(payload.dateInit, 1);
  state.cardPurchase.dateEndPast = subMonths(payload.dateEnd, 1);
};

const handleCardPisCofinsReducer = (state, { payload }) => {
  state.cardPisCofins.dateInit = payload.dateInit;
  state.cardPisCofins.dateEnd = payload.dateEnd;
  state.cardPisCofins.dateRange = payload.dateRange;
};

const handleCardIcmsReducer = (state, { payload }) => {
  state.cardIcms.dateInit = payload.dateInit;
  state.cardIcms.dateEnd = payload.dateEnd;
  state.cardIcms.dateRange = payload.dateRange;
};

const handleCardMiniVendasTotalsReducer = (state, { payload }) => {
  state.cardMiniVendasTotals.dateInit = payload.dateInit;
  state.cardMiniVendasTotals.dateEnd = payload.dateEnd;
  state.cardMiniVendasTotals.dateRange = payload.dateRange;
};

const handleCardMiniComprasTotalsReducer = (state, { payload }) => {
  state.cardMiniComprasTotals.dateInit = payload.dateInit;
  state.cardMiniComprasTotals.dateEnd = payload.dateEnd;
  state.cardMiniComprasTotals.dateRange = payload.dateRange;
};

const handleCardMiniSkuVendidosTotalsReducer = (state, { payload }) => {
  state.cardMiniSkuVendidosTotals.dateInit = payload.dateInit;
  state.cardMiniSkuVendidosTotals.dateEnd = payload.dateEnd;
  state.cardMiniSkuVendidosTotals.dateRange = payload.dateRange;
};

const handleCardDinheiroNaMesaReducer = (state, { payload }) => {
  state.cardDinheiroMesa.dateInit = payload.dateInit;
  state.cardDinheiroMesa.dateEnd = payload.dateEnd;
  state.cardDinheiroMesa.dateRange = payload.dateRange;
};

const handleCardCuidadoTentacaoReducer = (state, { payload }) => {
  state.cardCuidadoTentacao.dateInit = payload.dateInit;
  state.cardCuidadoTentacao.dateEnd = payload.dateEnd;
  state.cardCuidadoTentacao.dateRange = payload.dateRange;
};

const handleCardQueimaCaixaReducer = (state, { payload }) => {
  state.cardQueimaCaixa.dateInit = payload.dateInit;
  state.cardQueimaCaixa.dateEnd = payload.dateEnd;
  state.cardQueimaCaixa.dateRange = payload.dateRange;
};

const handleCardRiscoAssumidoReducer = (state, { payload }) => {
  state.cardRiscoAssumido.dateInit = payload.dateInit;
  state.cardRiscoAssumido.dateEnd = payload.dateEnd;
  state.cardRiscoAssumido.dateRange = payload.dateRange;
};

const handleCardProdutosVendidosReducer = (state, { payload }) => {
  state.cardProdutosVendidos.dateInit = payload.dateInit;
  state.cardProdutosVendidos.dateEnd = payload.dateEnd;
  state.cardProdutosVendidos.dateRange = payload.dateRange;
};

const handleCardDeOlhoMargemReducer = (state, { payload }) => {
  state.cardOlhoMargem.dateInit = payload.dateInit;
  state.cardOlhoMargem.dateEnd = payload.dateEnd;
  state.cardOlhoMargem.dateRange = payload.dateRange;
};

const handleAlertsModalReducer = (state, { payload }) => {
  state.alertsModal.isOpen = payload.isOpen;
  state.alertsModal.alert = payload.alert;
};

const handlePeriodReducer = (state, { payload }) => {
  state.periodMonthly = payload;
};

const handleSelectTagReducer = (state, { payload }) => {
  state.tag = payload;
  state.cardAll.tag = payload;
  state.cardSale.tag = payload;
  state.cardPurchase.tag = payload;
  state.cardPisCofins.tag = payload;
  state.cardIcms.tag = payload;
  state.cardMiniVendasTotals.tag = payload;
  state.cardMiniComprasTotals.tag = payload;
  state.cardMiniSkuVendidosTotals.tag = payload;
  state.cardDinheiroMesa.tag = payload;
  state.cardCuidadoTentacao.tag = payload;
  state.cardQueimaCaixa.tag = payload;
  state.cardRiscoAssumido.tag = payload;
  state.cardReprecificacao.tag = payload;
  state.cardProdutosVendidos.tag = payload;
  state.cardOlhoMargem.tag = payload;
};

const handleCardAllDateReducer = (state, payload) => {
  state.cardAll.dateInit = payload.payload.dateInit;
  state.cardAll.dateEnd = payload.payload.dateEnd;
  state.cardAll.dateRange = payload.payload.dateRange;

  handleCardSaleReducer(state, payload);
  handleCardPurchaseReducer(state, payload);
  handleCardPisCofinsReducer(state, payload);
  handleCardIcmsReducer(state, payload);
  handleCardDinheiroNaMesaReducer(state, payload);
  handleCardCuidadoTentacaoReducer(state, payload);
  handleCardQueimaCaixaReducer(state, payload);
  handleCardRiscoAssumidoReducer(state, payload);
  handleCardProdutosVendidosReducer(state, payload);

  handleCardMiniVendasTotalsReducer(state, payload);
  handleCardMiniComprasTotalsReducer(state, payload);
  handleCardMiniSkuVendidosTotalsReducer(state, payload);
  handleCardDeOlhoMargemReducer(state, payload);
};

const initialDashboard = () => {
  const item = window.localStorage.getItem("app-dashboard");
  //** Parse stored json or if none return initialValue
  return item ? JSON.parse(item) : dashboardDefault;
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialDashboard(),
  reducers: {
    handleCardSale: handleCardSaleReducer,
    handleCardPurchase: handleCardPurchaseReducer,
    handleCardPisCofins: handleCardPisCofinsReducer,
    handleCardIcms: handleCardIcmsReducer,
    handleCardMiniVendasTotals: handleCardMiniVendasTotalsReducer,
    handleCardMiniComprasTotals: handleCardMiniComprasTotalsReducer,
    handleCardMiniSkuVendidosTotals: handleCardMiniSkuVendidosTotalsReducer,
    handleCardDinheiroNaMesa: handleCardDinheiroNaMesaReducer,

    handleCardCuidadoTentacao: handleCardCuidadoTentacaoReducer,

    handleCardQueimaCaixa: handleCardQueimaCaixaReducer,
    handleCardRiscoAssumido: handleCardRiscoAssumidoReducer,
    handleCardProdutosVendidos: handleCardProdutosVendidosReducer,
    handleCardMargem: handleCardDeOlhoMargemReducer,

    handleCardAllDate: handleCardAllDateReducer,
    handleAlertsModal: handleAlertsModalReducer,
    handlePeriod: handlePeriodReducer,
    handleSelectTag: handleSelectTagReducer,
  },
});

export const {
  handleCardSale,
  handleCardPurchase,
  handleCardPisCofins,
  handleCardIcms,
  handleCardMiniComprasTotals,
  handleCardMiniSkuVendidosTotals,
  handleCardMiniVendasTotals,
  handleCardDinheiroNaMesa,
  handleCardCuidadoTentacao,
  handleCardQueimaCaixa,
  handleCardRiscoAssumido,
  handleCardProdutosVendidos,
  handleCardMargem,
  handleCardAllDate,
  handleAlertsModal,
  handlePeriod,
  handleSelectTag,
} = dashboardSlice.actions;

export default dashboardSlice.reducer;
